import React from "react";
import { Avatar } from "@mui/material";
import { ReactComponent as Male } from "../../assets/svg/male.svg";
import { ReactComponent as Female } from "../../assets/svg/female.svg";

function AvatarGender({ gender, size }) {
    const gen = gender?.toLowerCase();

    return (
        <Avatar
            sx={{
                bgcolor: "#fafafa",
                width: size,
                height: size,
            }}
        >
            {gen === "male" ? (
                <Male />
            ) : gen === "female" ? (
                <Female />
            ) : (
                <Avatar
                    sx={{
                        width: "100%",
                        height: "100%",
                        bgcolor: (theme) => theme.palette.primary.light,
                        fontSize: {
                            xs: "0.6rem", sm: "0.7rem", md: "0.8rem", lg: "0.9rem", xl: "2.2rem",
                        },
                    }}
                >
                    IN
                </Avatar>
            )}
        </Avatar>
    );
}

export default AvatarGender;
